export const LOADING_SALESPERSON = "LOADING_SALESPERSON";
export const GET_SALESPERSON_LIST = "GET_SALESPERSON_LIST";
